import Vue from 'vue'
import App from './App.vue'
import Header from '@/components/header';
import Footer from '@/components/footer';
import TypeNav from '@/components/typeNav';
import NoticeBox from '@/components/noticeBox';
import DetailBox from '@/components/detailBox';
import "@/assets/font/font.css"
//引入路由功能
import router from '@/router';
//注册仓库功能
import store from './store';
// 移动端适配
// import 'amfe-flexible'

Vue.component(Footer.name, Footer);
Vue.component(Header.name, Header);
Vue.component(TypeNav.name, TypeNav);
Vue.component(NoticeBox.name, NoticeBox);
Vue.component(DetailBox.name, DetailBox);
Vue.config.productionTip = false

// 按需引入element-ui
import { Pagination, Tooltip } from 'element-ui';
Vue.use(Pagination);
Vue.use(Tooltip);

// router.beforeEach((to, from, next) => {
//   // 检查即将进入的路由
//   if (to.path != '/detail') {
//     // 如果不是/detail路由，则确保加载reset.css
//     require('/public/reset.css');
//   } else {
//     // 如果是/detail路由，则不加载或卸载reset.css
//     // 这里的实现取决于您的项目结构和需求
//   }
//   next(); // 确保路由继续进行
// });

new Vue({
  render: h => h(App),
  // 注册路由
  router,
  // 注册仓库
  store,
}).$mount('#app')
